import React, {forwardRef} from "react";
import styled from "@emotion/styled";

/*
    props
    htmlFor : string
    label_name : string
 */
const CustomLabel = forwardRef((props, ref) => {
    // css style
    const {view} = useComponentStyle();

    return (
        <view.Label
            htmlFor={props.htmlFor}
            onClick={() => {
                if (!ref) {
                    return false;
                } else {
                    ref.current.focus();
                }
            }}>
            {props.label_name}
        </view.Label>
    );
});

export default CustomLabel;

export const useComponentStyle = () => {
    return {
        view: {
            Label: styled.div({
                fontWeight: "700",
            }),
        },
    };
};
